module.exports = __webpack_public_path__ + "media/images/common/menu_btn5-6c618359474a58044d4377eac49aae95.png";